import { Link, useColorMode } from "@chakra-ui/react";

export const ThemedLink = (props) => {
  const { colorMode } = useColorMode();
  const linkColor = colorMode === "dark" ? "#f7931a" : "#0d579b";

  return <Link {...props} color={linkColor} _hover={{ textDecoration: "none", color: linkColor }} />;
};
